var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1136_766",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1136_766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5896 17.4871H20.4101V17.2666C20.4101 16.5623 19.9939 15.9786 19.1614 15.5153C18.3289 15.0521 17.2751 14.8204 15.9999 14.8204C14.7247 14.8204 13.6708 15.0521 12.8383 15.5153C12.0059 15.9786 11.5896 16.5623 11.5896 17.2666V17.4871ZM15.9999 12.6666C16.5623 12.6666 17.0362 12.4739 17.4217 12.0884C17.8071 11.7029 17.9999 11.229 17.9999 10.6666C17.9999 10.1042 17.8071 9.63026 17.4217 9.24479C17.0362 8.85932 16.5623 8.66659 15.9999 8.66659C15.4375 8.66659 14.9635 8.85932 14.5781 9.24479C14.1926 9.63026 13.9999 10.1042 13.9999 10.6666C13.9999 11.229 14.1926 11.7029 14.5781 12.0884C14.9635 12.4739 15.4375 12.6666 15.9999 12.6666ZM8.10244 22.6666L5.83064 24.9384C5.49389 25.2751 5.10457 25.3525 4.66268 25.1705C4.22081 24.9884 3.99988 24.6572 3.99988 24.1769V6.15376C3.99988 5.54009 4.20543 5.0277 4.61654 4.61659C5.02766 4.20548 5.54004 3.99992 6.15371 3.99992H25.846C26.4597 3.99992 26.9721 4.20548 27.3832 4.61659C27.7943 5.0277 27.9999 5.54009 27.9999 6.15376V20.5128C27.9999 21.1264 27.7943 21.6388 27.3832 22.0499C26.9721 22.461 26.4597 22.6666 25.846 22.6666H8.10244ZM7.17934 21.3333H25.846C26.0512 21.3333 26.2392 21.2478 26.4101 21.0769C26.5811 20.9059 26.6665 20.7179 26.6665 20.5128V6.15376C26.6665 5.94865 26.5811 5.76061 26.4101 5.58966C26.2392 5.41872 26.0512 5.33326 25.846 5.33326H6.15371C5.9486 5.33326 5.76057 5.41872 5.58961 5.58966C5.41868 5.76061 5.33321 5.94865 5.33321 6.15376V23.1794L7.17934 21.3333Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.b811518c73a3bdab9c15d7fea3df601d.svg";
export { ForwardRef as ReactComponent };